import { render, staticRenderFns } from "./joinContent.vue?vue&type=template&id=566a2361&scoped=true&"
import script from "./joinContent.vue?vue&type=script&lang=js&"
export * from "./joinContent.vue?vue&type=script&lang=js&"
import style0 from "./joinContent.vue?vue&type=style&index=0&id=566a2361&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566a2361",
  null
  
)

export default component.exports